import dayjs from 'dayjs';

export const joinObjectValues = (
    item: Record<string, any>,
    keys: string[],
    divider = ' ',
    fallback = '—'
): string => {
    if (!item || keys.length === 0) return fallback;

    return (
        keys
            .map(key => item?.[key])
            .filter(v => v != null && v !== '') // прибирає null/undefined/пусті строки
            .join(divider) || fallback
    );
};

export const formatDateLabel = (
    value?: string | null,
    fallback: string = '—'
): string => {
    if (!value) return fallback;

    const date = dayjs(value);
    return date.isValid() ? date.format('DD.MM.YYYY') : fallback;
};

export const formatDateTimeLabel = (
    value?: string | null,
    fallback: string = '—'
): string => {
    if (!value) return fallback;

    const date = dayjs(value);
    return date.isValid() ? date.format('DD.MM.YYYY | HH:mm') : fallback;
};

export const formatFileSize = (
    value?: number | string | null,
    fallback: string = '—'
): string => {
    if (value === undefined || value === null) {
        return fallback;
    }

    const numericValue =
        typeof value === 'string' ? Number.parseFloat(value) : value;

    if (!Number.isFinite(numericValue)) {
        return fallback;
    }

    if (numericValue === 0) {
        return '0 B';
    }

    const units = ['B', 'KB', 'MB', 'GB'];
    const index = Math.min(
        Math.floor(Math.log(numericValue) / Math.log(1024)),
        units.length - 1
    );
    const size = numericValue / Math.pow(1024, index);

    return `${size >= 10 ? size.toFixed(0) : size.toFixed(1)} ${units[index]}`;
};
